import React from 'react';

import {TalentGraphLoad} from './TalentGraph.load';

export default function TalentGraph():JSX.Element {
	return (
		<TalentGraphLoad />
	);
}